import { connect } from 'react-redux'
import Sidebar from './Sidebar'
import { toggleMenu } from 'features/Layout/Layout.actions'
import { logout, switchBackToAdmin } from 'features/Auth/Auth.actions'

const stateToProps = ({ layout, auth }) => ({
  layout,
  user: auth.user,
  adminUserId: auth.adminUserId,
})

const dispatchToProps = {
  toggleMenu,
  logout,
  switchBackToAdmin,
}

export default connect(stateToProps, dispatchToProps)(Sidebar)



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.container.js